var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { DataSource } from '@angular/cdk/table';
import { EventEmitter, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs/Rx';
var CustomerTeamTableComponent = /** @class */ (function () {
    function CustomerTeamTableComponent() {
        this.removeMember = new EventEmitter();
        this.dataChange = new BehaviorSubject([]);
    }
    Object.defineProperty(CustomerTeamTableComponent.prototype, "team", {
        set: function (data) {
            this.dataChange.next(data);
        },
        enumerable: true,
        configurable: true
    });
    CustomerTeamTableComponent.prototype.ngOnInit = function () {
        this.displayedColumns = ['firstName', 'lastName', 'email', 'role', 'action'];
        this.dataSource = new CustomerTeamDataSource(this.dataChange.asObservable());
    };
    return CustomerTeamTableComponent;
}());
export { CustomerTeamTableComponent };
var CustomerTeamDataSource = /** @class */ (function (_super) {
    __extends(CustomerTeamDataSource, _super);
    function CustomerTeamDataSource(data) {
        var _this = _super.call(this) || this;
        _this.data = data;
        return _this;
    }
    CustomerTeamDataSource.prototype.connect = function () {
        return this.data;
    };
    CustomerTeamDataSource.prototype.disconnect = function () {
        // lint
    };
    return CustomerTeamDataSource;
}(DataSource));
export { CustomerTeamDataSource };
